export default "__VITE_ASSET__DL1dOnTp__"